<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import type { MaterialSymbolName } from '@/types/materialSymbolNames';
import type { ButtonVariant, ButtonSize } from './BaseButton.vue';

const props = withDefaults(
  defineProps<{
    icon: MaterialSymbolName;
    alt: string;
    type?: 'submit' | 'button';
    size?: ButtonSize;
    variant?: ButtonVariant;
    destructive?: boolean;
    active?: boolean;
    loading?: boolean;
    disabled?: boolean;
    route?: RouteLocationRaw;
    class?: HTMLAttributes['class'];
  }>(),
  {
    type: 'button',
    size: undefined,
    // This is a different default variant to the BaseButton component: largely
    // for legacy reasons, but also because it is far more common
    variant: 'text',
    route: undefined,
    class: undefined,
  },
);
</script>

<template>
  <BaseTooltip :text="alt" as-child>
    <BaseButton
      :type
      :size
      :variant
      :destructive
      :active
      :icon
      :loading
      :disabled
      :route
      :alt
      class="icon-button"
      :class="props.class"
    />
  </BaseTooltip>
</template>
